export default function (obj, path) {
    path = path.replace(/\[/g, '.').replace(/]/g, '').split('.');
    path.forEach(function (level) {
        if (obj === undefined || obj === null) {
            return undefined;
        }
        obj = obj[level];
    });

    return obj;
}